import { EditorState, Selection, TextSelection } from 'prosemirror-state'

import { schema } from '@showrunner/prose-schemas'

import { titlePageViewPluginKey } from './titlePageViewPlugin'
import { TitlePageViewState } from './types'

/**
 * Get the current title page view state
 */
export function getTitlePageViewState(
  state: EditorState,
): TitlePageViewState | undefined {
  return titlePageViewPluginKey.getState(state)
}

export function hasTitlePage(editorState: EditorState): boolean {
  return editorState.doc.firstChild?.type === schema.nodes.titlePage
}

export function isInTitlePage(pos: number, editorState: EditorState): boolean {
  const firstChild = editorState.doc.firstChild
  return (
    firstChild?.type === schema.nodes.titlePage && pos < firstChild.nodeSize
  )
}

/**
 * Finds the appropriate selection when switching title page visibility.
 * Returns a selection if the cursor needs to move, or null if no change needed.
 */
export function findVisibleSelection(
  state: EditorState,
  showTitlePageView: boolean,
): Selection | null {
  if (!hasTitlePage(state)) return null

  const titlePage = state.doc.firstChild!
  const fromInTitlePage = isInTitlePage(state.selection.from, state)

  if (showTitlePageView && !fromInTitlePage) {
    return TextSelection.findFrom(state.doc.resolve(1), 1) ?? null
  }

  if (!showTitlePageView && fromInTitlePage) {
    return (
      TextSelection.findFrom(state.doc.resolve(titlePage.nodeSize), 1) ?? null
    )
  }

  return null
}
